import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

export default function PaymentCancel() {
  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Checkout Cancelled — Motion & Meaning";
  }, []);

  return (
    <section className="min-h-screen flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9 }}
        className="text-center max-w-lg"
      >
        <p className="font-mono text-[11px] tracking-[0.4em] text-white/50 mb-6">CHECKOUT CANCELLED</p>
        <h1 className="font-serif text-5xl md:text-6xl text-white">Nothing was charged.</h1>
        <p className="text-white/50 mt-6">Your cart is still intact. Return when you're ready.</p>
        <button
          onClick={() => navigate("/store")}
          className="mt-12 bg-gold text-black font-mono text-[11px] tracking-[0.25em] px-9 py-4 hover:bg-white transition-colors"
          data-testid="cancel-back-store"
        >
          RETURN TO STORE
        </button>
      </motion.div>
    </section>
  );
}
